import { GET_POSITIONS_SUCCESS } from '../constants/positions';

export default (state = [], action) => {
  switch (action.type) {
    case GET_POSITIONS_SUCCESS:
      return action.payload && action.payload.length > 0
        ? [...action.payload]
        : [...state];

    default:
      return state;
  }
};
